import { ZERO } from '@constants';
import { AccordionDetails, AccordionSummary, StepLabel, StepLabelProps, styled } from '@mui/material';

export const StyledSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: '0px',
  minHeight: 'unset',
  '&.Mui-expanded': {
    margin: ZERO,
    minHeight: 'var(--commonMinHeight)',
  },
  '.MuiAccordionSummary-content': {
    margin: ZERO,
    '&.Mui-expanded': {
      margin: ZERO,
    },
  },
}));

interface StyledStepLabelProps extends StepLabelProps {
  active: boolean;
  isSubStep?: boolean;
}

export const StyledStepLabel = styled(StepLabel, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'isSubStep',
})<StyledStepLabelProps>(({ theme, active, isSubStep }) => {
  let padding = 'normal';
  let borderLeft = 'none';
  let background = 'none';
  let fontWeight = '600';
  let labelColor = theme.palette.text.secondary;

  if (isSubStep) {
    padding = '8px 16px 8px 32px';
    fontWeight = '400';
  }

  if (active) {
    labelColor = theme.palette.primary.main;
  }

  if (active && isSubStep) {
    borderLeft = `2px solid ${theme.palette.primary.main}`;
    background = '#000D1A0A';
    labelColor = '#000000E0';
  }

  if (active && isSubStep && theme.palette.mode === 'dark') {
    background = '#80C1FF14';
    labelColor = '#FFF';
  }

  if (isSubStep && theme.palette.mode === 'dark') {
    labelColor = '#FFF';
  }

  return {
    alignItems: 'flex-end',
    cursor: 'pointer',
    width: '100%',
    padding,
    borderLeft,
    background,

    '& .MuiStepLabel-labelContainer': {
      '& .MuiStepLabel-label': {
        color: labelColor,
        fontSize: '14px',
        fontWeight: fontWeight,
      },
    },

    '& .MuiStepLabel-iconContainer': {
      display: 'none',
    },
  };
});

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 'unset',
}));
